export const INTERESTS: string[] = [
  "Piano",
  "Hiking",
  "3D Modeling & Printing",
  "Electric Guitar",
];
